import { Box, Container, Divider, Grid } from "@mui/material"
import { ThemeProvider } from "../../../src/theme/ThemeContext2"
// import OrderPanel from "./ui/OrderPanel"
// import OrderDialogManager from "./ui/OrderDialogManager"
import { useMenuItems } from "./hooks/useMenuItems"
import "./style.css"
// import RestaurantInfo from "./ui/RestaurantInfo"
import { useSelector } from "react-redux"
import POSHeader from "components/POSHeader"
import MenuCategories from "components/MenuCategoryTabs/MenuCategories"
import OrderSummary from "components/OrderSummary/OrderSummary"
import MenuItemCardList from "components/MenuItemCardList"
import { orderSummary } from "utils/constant"
import { OrderProvider } from "context/OrderContext"
import RestaurantInfo from "components/RestaurantInfo/RestaurantInfo"
import OrderPanel from "components/OrderPanel"
import OrderDialogManager from "components/Modal/OrderDialog/OrderDialogManager"
import { useGetSummaryQuery } from "./services"

export default function RestaurantPOS() {
  const { menuItems, categories, activeCategory, setActiveCategory, searchQuery, setSearchQuery,
    isFetchingItems, isLoading } = useMenuItems()
  const userData = useSelector((state) => state?.posData)
  const { data: summaryData } = useGetSummaryQuery();

  const orderSummary = [
    {
      id: "1",
      title: "Total Orders",
      subtitle: "(Today)",
      value: summaryData?.data?.totalOrdersToday || 0,
      highlight: true,
    },
    {
      id: "2",
      title: "Takeaway Orders",
      value: summaryData?.data?.totalTakeAwayOrdersCount || 0,
      highlight: true,
    },
    {
      id: "3",
      title: "Delivery Orders",
      value: summaryData?.data?.totalDeliveryOrdersCount || 0,
      highlight: true,
    },
    {
      id: "4",
      title: "Available Tables",
      value: `${summaryData?.data?.availableTablesNow || 0}/${summaryData?.data?.totalTables || 0}`,
      highlight: true,
    },
  ]
  return (
    <ThemeProvider>
      {/* <OrderProvider> */}
      <Box sx={{ bgcolor: "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <POSHeader />
        <Box className="pos-container" sx={{ flexGrow: 1 }}>
          <Container
            maxWidth={false}
            disableGutters
            sx={{
              px: { xs: 1, sm: 2, md: 3 },
              py: 2,
              maxWidth: "1400px",
              mx: "auto",
            }}
          >
            <Grid container spacing={{ xs: 1, sm: 2 }}>
              <Grid item xs={12} lg={8}>
                <Box>
                  <OrderSummary orderSummary={orderSummary} />
                  <Divider sx={{ mt: 2 }} />
                  <Box sx={{ mt: 2 }}>
                    <MenuCategories
                      categories={categories}
                      activeCategory={activeCategory}
                      onCategoryChange={setActiveCategory}
                      isLoading={isLoading}
                    />

                    <MenuItemCardList
                      items={menuItems}
                      searchQuery={searchQuery}
                      onSearchChange={setSearchQuery}
                      isLoading={isFetchingItems}
                    />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} lg={4}>
                {/* <RestaurantInfo name={userData?.vendor?.name} description={userData?.vendor?.tagline} /> */}
                <Box>
                  <OrderPanel />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <OrderDialogManager />
      </Box>
      {/* </OrderProvider> */}
    </ThemeProvider>
  )
}
